// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cellspace {
  color: #344049;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;

}

.payer-label {
  margin-left: 5px;
 
  color: #344049;
  

}

/* .ag-floating-filter-button {
  display: none !important;
 
} */


.fullerror-ag .ag-theme-alpine .ag-header-cell.ag-header-active .ag-header-cell-menu-button, .ag-header-cell-filter-button{
  display: none !important;
}

.fullerror-ag .ag-theme-alpine .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon, .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon{
  display: none !important;
}


.fullerror-ag .ag-theme-alpine {
  border-collapse: collapse;
 
  width: 100%;

}

/*Aggrid Number it was hiding number*/
.fullerror-ag .ag-theme-alpine .ag-floating-filter .ag-floating-filter-input .ag-number-field-input-wrapper .ag-input-field-input {
  border: none !important;
  color: #344049 !important;
  font-weight: 400 !important;
}


.valueStyle {
  color: #344049;
  font-style: normal;
  /* text-decoration-line: underline; */
  text-decoration-style: solid;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}


.customTypography {
  color: #344049;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}



`, "",{"version":3,"sources":["webpack://./src/components/view-errors-and-fixes/view-errors/recon.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;;EAEhB,cAAc;;;AAGhB;;AAEA;;;GAGG;;;AAGH;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,yBAAyB;;EAEzB,WAAW;;AAEb;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;AAC7B;;;AAGA;EACE,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,sCAA8B;UAA9B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;;;AAGA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB","sourcesContent":[".cellspace {\n  color: #344049;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n\n}\n\n.payer-label {\n  margin-left: 5px;\n \n  color: #344049;\n  \n\n}\n\n/* .ag-floating-filter-button {\n  display: none !important;\n \n} */\n\n\n.fullerror-ag .ag-theme-alpine .ag-header-cell.ag-header-active .ag-header-cell-menu-button, .ag-header-cell-filter-button{\n  display: none !important;\n}\n\n.fullerror-ag .ag-theme-alpine .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon, .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-menu-icon{\n  display: none !important;\n}\n\n\n.fullerror-ag .ag-theme-alpine {\n  border-collapse: collapse;\n \n  width: 100%;\n\n}\n\n/*Aggrid Number it was hiding number*/\n.fullerror-ag .ag-theme-alpine .ag-floating-filter .ag-floating-filter-input .ag-number-field-input-wrapper .ag-input-field-input {\n  border: none !important;\n  color: #344049 !important;\n  font-weight: 400 !important;\n}\n\n\n.valueStyle {\n  color: #344049;\n  font-style: normal;\n  /* text-decoration-line: underline; */\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n\n\n.customTypography {\n  color: #344049;\n  text-align: center;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.ellipsis-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  display: block;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
